import React, { useEffect, useState } from 'react';
import './EventosHome.css';
import baseURL from '../url';
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper/core';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCalendarAlt,
    faTimes,
    faChevronLeft,
    faChevronRight,
    faMapMarkerAlt
} from '@fortawesome/free-solid-svg-icons';
import whatsappIcon from '../../images/wpp.png';

SwiperCore.use([Navigation, Pagination, Autoplay]);

const FESTIVIDADES_DEFAULT = [
    {
        idEvento: 'f1',
        nombre: 'Fiesta de San Juan',
        categoria: 'Fiesta Patronal',
        fecha: '24 de Junio',
        ubicacion: 'Tingo María - Selva Central',
        imagen: '/imagenes_lugares/fiesta_san_juan.jpg',
        descripcion: 'La celebración más emblemática de la Amazonía: concurso de juanes, baños de purificación en ríos, comparsas y música tradicional selvática.'
    },
    {
        idEvento: 'f2',
        nombre: 'Aniversario de Tingo María',
        categoria: 'Festividad Cívica',
        fecha: '15 de Octubre',
        ubicacion: 'Plaza de Armas y Miradores',
        imagen: '/imagenes_lugares/bella_durmiente.jpg',
        descripcion: 'Gran fiesta con desfiles alegóricos, ferias gastronómicas de cacao y café, certamen Miss Tingo María y serenatas a la Bella Durmiente.'
    },
    {
        idEvento: 'f3',
        nombre: 'Semana Santa en la Selva',
        categoria: 'Turismo Religioso y Naturaleza',
        fecha: 'Marzo / Abril',
        ubicacion: 'Parque Nacional Tingo María',
        imagen: '/imagenes_lugares/cueva_lechuzas.jpg',
        descripcion: 'Vive el recogimiento y la aventura recorriendo circuitos de cataratas, cuevas místicas y degustación de la deliciosa gastronomía de río.'
    },
    {
        idEvento: 'f4',
        nombre: 'Festival de la Aventura y Selva',
        categoria: 'Deporte & Aventura',
        fecha: 'Agosto',
        ubicacion: 'Cataratas Honolulu y Jacintillo',
        imagen: '/imagenes_lugares/rapel_honolulu.jpg',
        descripcion: 'Competencias de rapel en cascadas, trekking por la selva, canotaje y campamentos ecológicos con guías certificados.'
    }
];

export default function EventosHome() {
    const [eventos, setEventos] = useState([]);
    const [eventoSeleccionado, setEventoSeleccionado] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [telefonoContacto, setTelefonoContacto] = useState('');

    useEffect(() => {
        cargarEventos();
        cargarContacto();
    }, []);

    const formatearFecha = (fecha) => {
        if (!fecha || fecha.trim() === '') return null;
        try {
            if (fecha.includes('-')) {
                const parts = fecha.split('-');
                if (parts.length === 3) {
                    const meses = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
                    const mesIndex = parseInt(parts[1], 10) - 1;
                    const mes = meses[mesIndex] || parts[1];
                    const dia = parseInt(parts[2], 10);
                    return `${dia} de ${mes}`;
                }
            }
        } catch (_) { }
        return fecha;
    };

    const obtenerImagenEvento = (evento) => {
        if (evento?.imagen && evento.imagen.trim() !== '') {
            return evento.imagen;
        }
        return '/imagenes_lugares/fiesta_san_juan.jpg';
    };

    const cargarEventos = () => {
        fetch(`${baseURL}/eventosGet.php`, {
            method: 'GET',
        })
            .then(res => res.json())
            .then(data => {
                const apiEventos = data.eventos || [];
                if (apiEventos.length > 0) {
                    setEventos(apiEventos);
                } else {
                    setEventos(FESTIVIDADES_DEFAULT);
                }
            })
            .catch(err => {
                console.error('Error al cargar eventos:', err);
                setEventos(FESTIVIDADES_DEFAULT);
            });
    };

    const cargarContacto = () => {
        fetch(`${baseURL}/contactoGet.php`, { method: 'GET' })
            .then(res => res.json())
            .then(data => {
                const contactos = data.contacto || [];
                if (contactos.length > 0 && contactos[0]?.telefono) {
                    setTelefonoContacto(contactos[0].telefono.replace(/\D/g, ''));
                }
            })
            .catch(err => console.error('Error al cargar contacto:', err));
    };

    const abrirDetalle = (evento) => {
        setEventoSeleccionado(evento);
        setModalOpen(true);
    };

    const cerrarDetalle = () => {
        setModalOpen(false);
        setEventoSeleccionado(null);
    };

    const consultarPorWhatsapp = (e, evento) => {
        e.stopPropagation();
        const phone = telefonoContacto || '51962850037';
        const fechaTexto = evento.fecha ? ` programado para ${formatearFecha(evento.fecha) || evento.fecha}` : '';
        const mensaje = `Hola Seylis Tours, quisiera consultar paquetes y más información sobre el evento: *${evento.nombre}*${fechaTexto}.`;
        const url = `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(mensaje)}`;
        window.open(url, '_blank');
    };

    if (eventos.length === 0) {
        return null;
    }

    return (
        <section className="eventosHomeSection" id="eventos-section">
            <div className="eventosHomeHeaderContainer">
                <div className="eventosHomeHeader">

                    <h2 className="eventosHomeTitle">
                        Próximas <span className="eventosHighlight">Festividades</span>
                    </h2>
                    <p className="eventosHomeSubtitle">
                        Participa en las festividades tradicionales más alegres durante el año en Tingo María y la selva central.
                    </p>
                </div>

                <div className="eventosCarouselNav">
                    <button className="swiper-prev-eventos" aria-label="Evento anterior" type="button">
                        <FontAwesomeIcon icon={faChevronLeft} />
                    </button>
                    <button className="swiper-next-eventos" aria-label="Siguiente evento" type="button">
                        <FontAwesomeIcon icon={faChevronRight} />
                    </button>
                </div>
            </div>

            <div className="eventosCarouselWrapper">
                <Swiper
                    navigation={{
                        prevEl: '.swiper-prev-eventos',
                        nextEl: '.swiper-next-eventos',
                    }}
                    pagination={{
                        clickable: true,
                        dynamicBullets: true
                    }}
                    slidesPerView={3}
                    spaceBetween={24}
                    breakpoints={{
                        320: {
                            slidesPerView: 1.15,
                            spaceBetween: 14,
                        },
                        640: {
                            slidesPerView: 2,
                            spaceBetween: 18,
                        },
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 24,
                        }
                    }}
                    className="eventosSwiper"
                >
                    {eventos.map((evento) => (
                        <SwiperSlide key={evento.idEvento} className="eventoSwiperSlide">
                            <article
                                className="eventoCard"
                                onClick={() => abrirDetalle(evento)}
                                title={`Click para ver más detalles de ${evento.nombre}`}
                            >
                                <div className="eventoCardImageWrap">
                                    <img
                                        src={obtenerImagenEvento(evento)}
                                        alt={evento.nombre}
                                        className="eventoCardImage"
                                        loading="lazy"
                                    />
                                    <div className="eventoCardGradient"></div>
                                </div>

                                <div className="eventoCardTopBadges">
                                    <span className="eventoPillTag">
                                        <FontAwesomeIcon icon={faCalendarAlt} /> {formatearFecha(evento.fecha) || evento.categoria || 'Evento'}
                                    </span>
                                </div>

                                <div className="eventoCardContent">
                                    <div className="eventoLocation">
                                        <FontAwesomeIcon icon={faMapMarkerAlt} />
                                        <span>{evento.ubicacion || evento.categoria || 'Tingo María, Perú'}</span>
                                    </div>
                                    <h3 className="eventoCardTitle">{evento.nombre}</h3>
                                    <p className="eventoCardDesc">{evento.descripcion}</p>

                                </div>
                            </article>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>

            {/* Modal de Detalle de Festividad */}
            {modalOpen && eventoSeleccionado && (
                <div className="eventoModalBackdrop" onClick={cerrarDetalle}>
                    <div
                        className="eventoModalContent"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            type="button"
                            className="eventoModalCloseBtn"
                            onClick={cerrarDetalle}
                            aria-label="Cerrar modal"
                        >
                            <FontAwesomeIcon icon={faTimes} />
                        </button>

                        <div className="eventoModalTopTag">
                            {formatearFecha(eventoSeleccionado.fecha) || eventoSeleccionado.categoria || 'Evento'}
                        </div>

                        <div className="eventoModalImageWrap">
                            <img
                                src={obtenerImagenEvento(eventoSeleccionado)}
                                alt={eventoSeleccionado.nombre}
                                className="eventoModalImage"
                            />
                            <div className="eventoModalGradient"></div>
                        </div>

                        <div className="eventoModalBody">
                            <div className="eventoModalLocation">
                                <FontAwesomeIcon icon={faMapMarkerAlt} /> {eventoSeleccionado.ubicacion || eventoSeleccionado.categoria || 'Tingo María, Perú'}
                            </div>
                            <h2 className="eventoModalTitle">{eventoSeleccionado.nombre}</h2>
                            {eventoSeleccionado.descripcion && (
                                <p className="eventoModalDesc">{eventoSeleccionado.descripcion}</p>
                            )}

                            <button
                                type="button"
                                className="eventoModalWppBtn"
                                onClick={(e) => consultarPorWhatsapp(e, eventoSeleccionado)}
                            >
                                <img src={whatsappIcon} alt="whatsapp" className="wppMiniIcon" /> Consultar por WhatsApp
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
}
